var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _g2, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 108,
    viewBox: "0 0 124 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5245 19.4227C24.2578 19.843 23.7616 19.8827 23.3414 19.617L19.3107 16.5978C18.8905 16.3322 18.8518 15.8366 19.1185 15.4163C19.3851 14.996 19.8813 14.9563 20.3015 15.222L24.3322 18.2412C24.8098 18.602 24.8486 19.0976 24.5245 19.4227Z",
    fill: "#D9668F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8645 25.0111C23.7885 25.3164 23.6551 25.5265 23.3117 25.6039L18.7524 27.3148C18.3136 27.4496 17.798 27.2415 17.6639 26.8033C17.5297 26.3652 17.7391 25.8498 18.1779 25.715L22.7372 24.004C23.176 23.8692 23.6916 24.0774 23.8257 24.5155C23.8451 24.7633 23.9024 24.8584 23.8645 25.0111Z",
    fill: "#D9668F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6733 15.6691C29.578 15.7266 29.4252 15.6889 29.2345 15.8039C28.7763 15.6909 28.4515 15.3678 28.5081 14.8147L29.0747 9.93188C29.1886 9.47393 29.5127 9.1488 30.0662 9.2043C30.5244 9.31729 30.8493 9.64043 30.7927 10.1935L30.2261 15.0763C30.0927 15.2865 29.864 15.5541 29.6733 15.6691Z",
    fill: "#D9668F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1901 86.3189C82.7625 86.3189 100.25 68.7884 100.25 47.1634C100.25 25.5383 82.7625 8.00781 61.1901 8.00781C39.6178 8.00781 22.1299 25.5383 22.1299 47.1634C22.1299 68.7884 39.6178 86.3189 61.1901 86.3189Z",
    fill: "#F0F5FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4267 21.7949H87.9913C90.1919 21.7949 91.9209 23.5282 91.9209 25.7341V60.9505C91.9209 63.1564 90.1919 64.8897 87.9913 64.8897H32.4267C30.2261 64.8897 28.4971 63.1564 28.4971 60.9505V25.7341C28.4971 23.5282 30.3047 21.7949 32.4267 21.7949Z",
    fill: "#DAE2EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.592 37.4199C107.81 36.3045 107.895 34.4109 106.782 33.1903C105.67 31.9698 103.781 31.8845 102.563 32.9999C101.345 34.1153 101.26 36.009 102.373 37.2295C103.486 38.4501 105.375 38.5353 106.592 37.4199Z",
    fill: "#EAEEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2873 8.20866C44.3192 7.87242 44.8839 6.76125 44.5485 5.72677C44.2131 4.69229 43.1046 4.12626 42.0726 4.46249C41.0407 4.79872 40.476 5.9099 40.8114 6.94437C41.1468 7.97885 42.2553 8.54489 43.2873 8.20866Z",
    fill: "#EAEEF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6427 2.67865C55.3806 2.67865 55.9788 2.07901 55.9788 1.33932C55.9788 0.599636 55.3806 0 54.6427 0C53.9048 0 53.3066 0.599636 53.3066 1.33932C53.3066 2.07901 53.9048 2.67865 54.6427 2.67865Z",
    fill: "url(#paint0_linear_1106_4343)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.989 24.316C106.683 24.316 107.246 23.7516 107.246 23.0555C107.246 22.3593 106.683 21.7949 105.989 21.7949C105.294 21.7949 104.731 22.3593 104.731 23.0555C104.731 23.7516 105.294 24.316 105.989 24.316Z",
    fill: "url(#paint1_linear_1106_4343)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1464 5.63431C75.4988 5.31143 75.5235 4.76326 75.2014 4.40994C74.8793 4.05663 74.3324 4.03195 73.98 4.35483C73.6275 4.67771 73.6029 5.22587 73.925 5.57919C74.2471 5.93251 74.7939 5.95719 75.1464 5.63431Z",
    fill: "#EAEEF9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0335 44.3909V61.7233C93.0335 63.9292 91.226 65.8202 88.9468 65.8202H31.8104C29.6098 65.8202 27.7236 64.008 27.7236 61.7233V42.894",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1106_4343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.104 34.6812H70.1349C68.3862 34.6812 66.6979 35.2845 65.3714 36.3702L60.668 40.2304C59.3415 41.316 57.6531 41.9191 55.9045 41.9191H35.4631C33.4129 41.9191 31.7246 43.6081 31.7246 45.6588C31.7246 45.8397 31.7247 46.0206 31.785 46.2016L35.5235 66.1059C35.825 67.9757 37.3927 69.3629 39.262 69.3629H82.7976C84.6669 69.3629 86.2346 68.0361 86.5361 66.1663L91.7823 38.9637C92.144 36.9129 90.7571 35.043 88.707 34.6812C88.5261 34.6812 88.2849 34.6812 88.104 34.6812Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1106_4343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2551 29.3428H72.8346C70.5554 29.3428 68.3549 30.1308 66.6259 31.549L60.4957 36.591C58.7667 38.0091 56.5662 38.7968 54.287 38.7968H27.6442C24.972 38.7968 22.7715 41.0029 22.7715 43.6816C22.7715 43.9179 22.7716 44.1542 22.8502 44.3906L27.7228 70.3892C28.1158 72.8315 30.1591 74.6435 32.5955 74.6435H89.3389C91.7753 74.6435 93.8186 72.9104 94.2116 70.4681L101.049 34.9365C101.521 32.2579 99.7131 29.8155 97.041 29.3428C96.8052 29.3428 96.4909 29.3428 96.2551 29.3428Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.208 68.8917C110.117 69.164 110.117 69.527 110.027 69.7993C109.755 70.7977 109.484 71.7053 109.032 72.5221C106.951 77.1509 102.971 80.5997 98.1774 81.9611C97.906 82.0519 97.6346 82.1428 97.4537 82.1428C95.0115 82.7781 92.3884 82.8686 89.7653 82.3241C80.4487 80.4181 74.3886 71.1609 76.3785 61.8126C78.278 52.4643 87.504 46.3831 96.8206 48.3798C100.167 49.1059 103.152 50.7397 105.504 53.0995C109.574 57.1837 111.383 63.1738 110.208 68.8917Z",
    fill: "#FB4E4E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.589 65.6417L99.5723 62.6422C100.425 61.7852 100.425 60.4997 99.5723 59.6427C98.7199 58.7858 97.4414 58.7858 96.589 59.6427L93.6058 62.6422L90.6225 59.6427C89.7702 58.7858 88.4916 58.7858 87.6393 59.6427C86.7869 60.4997 86.7869 61.7852 87.6393 62.6422L90.6225 65.6417L87.6393 68.6411C86.7869 69.4981 86.7869 70.7836 87.6393 71.6406C88.0654 72.0691 88.6337 72.2119 89.2019 72.2119C89.7702 72.2119 90.3384 72.0691 90.7646 71.6406L93.7478 68.6411L96.7311 71.6406C97.5835 72.4976 98.862 72.4976 99.7144 71.6406C100.141 71.2121 100.283 70.6407 100.283 70.0694C100.283 69.4981 100.141 68.9268 99.7144 68.4983L96.589 65.6417Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1224 55.665C54.3851 55.665 55.4088 54.6413 55.4088 53.3784C55.4088 52.1155 54.3851 51.0918 53.1224 51.0918C51.8596 51.0918 50.8359 52.1155 50.8359 53.3784C50.8359 54.6413 51.8596 55.665 53.1224 55.665Z",
    fill: "#1C3754"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0481 55.5732C72.3109 55.5732 73.3346 54.5495 73.3346 53.2866C73.3346 52.0237 72.3109 51 71.0481 51C69.7854 51 68.7617 52.0237 68.7617 53.2866C68.7617 54.5495 69.7854 55.5732 71.0481 55.5732Z",
    fill: "#1C3754"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0232 59.4148H65.8344C64.8284 57.3111 62.2675 56.4879 60.2554 57.5855C59.4323 57.9513 58.7921 58.6831 58.4263 59.4148H57.2373C58.2433 56.6708 61.353 55.299 64.0053 56.3051C65.3771 56.8539 66.4744 57.9513 67.0232 59.4148Z",
    fill: "#1C3754"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1106_4343",
    x: 21.7246,
    y: 15.6812,
    width: 80.1152,
    height: 54.6816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_4343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1106_4343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1106_4343",
    x: 0.771484,
    y: 18.3428,
    width: 122.353,
    height: 89.3008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1106_4343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1106_4343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_4343",
    x1: 53.347,
    y1: 1.30592,
    x2: 55.9447,
    y2: 1.30592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1106_4343",
    x1: 104.775,
    y1: 23.0869,
    x2: 107.215,
    y2: 23.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.48ad3df92fabe20fcb5f4be0f287ff78.svg";
export { ForwardRef as ReactComponent };